var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'react-emotion';
import Slider from '@material-ui/core/Slider';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: column;\n  position: relative;\n  ", "\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  position: relative;\n  ", "\n"])), function (props) { return (props.half ? "width: 49.3%" : ""); });
export var SliderWrapper = styled('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 1px solid gray;\n  border-radius: 0.5em;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  width: 100%;\n  margin-top: 0.15em;\n"], ["\n  border: 1px solid gray;\n  border-radius: 0.5em;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  width: 100%;\n  margin-top: 0.15em;\n"])));
export var SliderBox = styled('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  width: 90%;\n  padding: 0.75em 0.5em;\n"], ["\n  align-items: center;\n  display: flex;\n  width: 90%;\n  padding: 0.75em 0.5em;\n"])));
export var CustomHelperText = styled('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 13px;\n"], ["\n  color: ", ";\n  font-size: 13px;\n"])), function (props) { return (props.error ? 'red' : 'rgba(0, 0, 0, 0.54)'); });
var BoxShadow = '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';
export var CustomSlider = styled(Slider)(function (_a) {
    var theme = _a.theme;
    return ({
        color: '#3F51B5',
        padding: '15px 0',
        '& .MuiSlider-valueLabel': {
            fontSize: 12,
            fontWeight: 'normal',
            top: -4,
            color: 'grey'
        },
        '& .MuiSlider-track': {
            border: 'none'
        },
        '& .MuiSlider-rail': {
            opacity: 0.5,
            backgroundColor: '#bfbfbf'
        }
    });
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=RangeSliderComponent.Styles.js.map